/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ChapterPanelModel } from '../model/chapterPanelModel';
import { CreateLearningSupportElementCommand } from '../model/createLearningSupportElementCommand';
import { DeleteLearningSupportElementCommand } from '../model/deleteLearningSupportElementCommand';
import { GetChapterPanelsQuery } from '../model/getChapterPanelsQuery';
import { GetLearningSupportElementsQuery } from '../model/getLearningSupportElementsQuery';
import { LearningSupportElementModel } from '../model/learningSupportElementModel';
import { RemoveLearningSupportElementCommand } from '../model/removeLearningSupportElementCommand';
import { UpdateLearningSupportElementCommand } from '../model/updateLearningSupportElementCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class LearningSupportElementsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public learningSupportElementsCreateLearningSupportElementPost(body?: CreateLearningSupportElementCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public learningSupportElementsCreateLearningSupportElementPost(body?: CreateLearningSupportElementCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public learningSupportElementsCreateLearningSupportElementPost(body?: CreateLearningSupportElementCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public learningSupportElementsCreateLearningSupportElementPost(body?: CreateLearningSupportElementCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/LearningSupportElements/CreateLearningSupportElement`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public learningSupportElementsDeleteLearningSupportElementDelete(body?: DeleteLearningSupportElementCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public learningSupportElementsDeleteLearningSupportElementDelete(body?: DeleteLearningSupportElementCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public learningSupportElementsDeleteLearningSupportElementDelete(body?: DeleteLearningSupportElementCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public learningSupportElementsDeleteLearningSupportElementDelete(body?: DeleteLearningSupportElementCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('delete',`${this.basePath}/LearningSupportElements/DeleteLearningSupportElement`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param query 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public learningSupportElementsGetChapterPanelsGet(query?: GetChapterPanelsQuery, observe?: 'body', reportProgress?: boolean): Observable<Array<ChapterPanelModel>>;
    public learningSupportElementsGetChapterPanelsGet(query?: GetChapterPanelsQuery, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ChapterPanelModel>>>;
    public learningSupportElementsGetChapterPanelsGet(query?: GetChapterPanelsQuery, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ChapterPanelModel>>>;
    public learningSupportElementsGetChapterPanelsGet(query?: GetChapterPanelsQuery, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', <any>query);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ChapterPanelModel>>('get',`${this.basePath}/LearningSupportElements/GetChapterPanels`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param query 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public learningSupportElementsGetCollectionGet(query?: GetLearningSupportElementsQuery, observe?: 'body', reportProgress?: boolean): Observable<Array<LearningSupportElementModel>>;
    public learningSupportElementsGetCollectionGet(query?: GetLearningSupportElementsQuery, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LearningSupportElementModel>>>;
    public learningSupportElementsGetCollectionGet(query?: GetLearningSupportElementsQuery, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LearningSupportElementModel>>>;
    public learningSupportElementsGetCollectionGet(query?: GetLearningSupportElementsQuery, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', <any>query);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<LearningSupportElementModel>>('get',`${this.basePath}/LearningSupportElements/GetCollection`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param actionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public learningSupportElementsGetLSEByActionGet(actionId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<LearningSupportElementModel>>;
    public learningSupportElementsGetLSEByActionGet(actionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LearningSupportElementModel>>>;
    public learningSupportElementsGetLSEByActionGet(actionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LearningSupportElementModel>>>;
    public learningSupportElementsGetLSEByActionGet(actionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (actionId === null || actionId === undefined) {
            throw new Error('Required parameter actionId was null or undefined when calling learningSupportElementsGetLSEByActionGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (actionId !== undefined && actionId !== null) {
            queryParameters = queryParameters.set('ActionId', <any>actionId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<LearningSupportElementModel>>('get',`${this.basePath}/LearningSupportElements/GetLSEByAction`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public learningSupportElementsGetSingleGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<LearningSupportElementModel>;
    public learningSupportElementsGetSingleGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LearningSupportElementModel>>;
    public learningSupportElementsGetSingleGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LearningSupportElementModel>>;
    public learningSupportElementsGetSingleGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling learningSupportElementsGetSingleGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('Id', <any>id);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<LearningSupportElementModel>('get',`${this.basePath}/LearningSupportElements/GetSingle`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public learningSupportElementsRemoveLearningSupportElementPut(body?: RemoveLearningSupportElementCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public learningSupportElementsRemoveLearningSupportElementPut(body?: RemoveLearningSupportElementCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public learningSupportElementsRemoveLearningSupportElementPut(body?: RemoveLearningSupportElementCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public learningSupportElementsRemoveLearningSupportElementPut(body?: RemoveLearningSupportElementCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/LearningSupportElements/RemoveLearningSupportElement`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public learningSupportElementsUpdateLearningSupportElementPut(body?: UpdateLearningSupportElementCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public learningSupportElementsUpdateLearningSupportElementPut(body?: UpdateLearningSupportElementCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public learningSupportElementsUpdateLearningSupportElementPut(body?: UpdateLearningSupportElementCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public learningSupportElementsUpdateLearningSupportElementPut(body?: UpdateLearningSupportElementCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/LearningSupportElements/UpdateLearningSupportElement`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
